module.exports = __webpack_public_path__ + "img/label-11SIMPLE.be5fc466.jpeg";